import React from "react";
import SubmissionFormsTable from "../components/forms/SubmissionFormsTable";

const NewDriverStatementSubmissionsTable: React.FC = () => (
  <SubmissionFormsTable
    apiSegment="new-driver-statement-submissions"
    title="טבלת טפסים לקבלה ולנהיגה ברכב צמוד"
    emptyLabel="אין הגשות להצגה"
    formPageUrl="https://rafael-car-show.co.il/new-driver-statement"
  />
);

export default NewDriverStatementSubmissionsTable;
